/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback, useEffect, useContext } from 'react';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import classNames from 'classnames';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useModal } from '@jutro/components';
import { FormattedMessage, useTranslator } from '@jutro/locale';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { MLBillingUtil, MLGafUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import {MLPaymentService, MLNavigationStepsTrackingService, MLStateRolloutService} from 'ml-services-common-react';
import { useMLLandingPageContext } from 'gw-capability-gateway-quoteandbind-common-react';
import { MLEndorsementUtil, MLEndorsementFlowUtil } from 'ml-portals-util-js';
import { MLGatewayAccountBillingDetailsService } from 'gw-capability-gateway-billing';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { MLModalService } from 'ml-portals-services-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { UserService, PolicyService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import {
    MLOutOfSequenceConflictComponent,
    MLWizardPageActions,
    MLPaymentMethodComponent,
    MLPaymentScheduleComponent,
    MLRecurringPaymentComponent,
    MLBankAccountDetailsComponent,
    MLCreditCardDetailsComponent,
    MLEmployersAffiliationsComponent,
} from 'ml-components-common-react';

import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';
import metadata from './BillingDetailsPagePolChange.metadata.json5';
import messages from './BillingDetailsPagePolChange.messages';
import styles from './BillingDetailsPagePolChange.module.scss';
import { Link } from '@jutro/router';

import { ScrollToError } from '@jutro/legacy/wizard-next';

// ==================== Constants (START) ==================== //
const ACCORDION_CARDS = {
    GROUP_DISCOUNT: 'groupDiscountCard',
    PAYMENT_METHOD: 'paymentMethodCard',
    PAYMENT_SCHEDULE: 'paymentScheduleCard',
    RECURRING_PAYMENT: 'recurringPaymentCard'
};

const DL_ACTIONS = {
    ADD_ACOUNT: 'addAccount',
    CANCEL: 'cancel',
    EDIT_ACCOUNT: 'editAccount'
};

const BOA_BANK_NAME = 'boa';
const JPMC_BANK_NAME = 'jpmc';
const RECURRING_INSTRUMENT_TYPE = 'recurring';
const REFRESH_DELAY = 500;
const NON_PREFERRED_PAYMENT_METHODS = ['VISA', 'MC', 'AMEX', 'DISC'];

const {
    portalCode,
    MLRatingPaymentMethods,
    MLUserTypes,
    MLProducerTypes,
    MLAccountPaymentMethods,
    MLJpmcResponsePath,
    mercerOrganization
} = appConfig;

const {
    MLAnnuallyPayPlanPublicId,
    MLMortgageePayPlanPublicId,
    MLMonthlyPayPlanPublicId,
    MLBiWeeklyPayPlanPublicId,
    MLTwicePerMonthPayPlanPublicId,
    MLTwoPayPlanPublicId,
    MLMonthlyAnnualResponsivePlanPublicId,
    MLMonthlySemiAnnualResponsivePlanPublicId,
    MLTwoPayAnnualPlanPublicId,
    MLTwoPaySemiAnnualPlanPublicId,
    MLFourPayAnnualPlanPublicId,
    MLPayrollDeductPlanPublicId,
    FMPAMonthlyAnnualResponsivePlanPublicId,
    FMPAMonthlySemiAnnualResponsivePlanPublicId
} = appConfig.mlPaymentPlan;

const gpaMode = portalCode === 'GPA';
const qnbMode = portalCode === 'QB';
const ampMode = portalCode === 'AMP';

const BillingDetailsPagePolChange = (props) => {
    const modalApi = useModal();
    const {
        showErrorModal,
        showProgressDialog,
    } = MLModalService();

    const {
        clearBlockAlerts,
        addWarningAlert,
        addErrorAlert,
        clearErrorAlerts
    } = MLNotificationBlockUtil();

    const {
        getPaymentMethodName
    } = MLBillingUtil();

    const { refreshData } = useDataRefresh();
    const { additionalPolicyChangeProps } = useMLLandingPageContext()

    // context/hooks/props
    const translator = useTranslator();
    const { wizardData, updateWizardData, goNext } = props;
    const { authHeader, authUserData } = useAuthentication();
    const { onValidate, isComponentValid } = useValidation('BillingDetailsPagePolChange');
    const {
        wizardData: {
            submissionVM: endorsementVM,
            bindData: view
        },
        currentStep,
        currentStepIndex,
        steps,
        jumpTo,
        changeNextSteps
    } = props;
    const { EndorsementService } = useDependencies('EndorsementService');

    // state
    const [expandGroupDiscountSection, setExpandGroupDiscountSection] = useState(() => { return !!endorsementVM.baseData.gafInfo_ML.gpcCode?.value });
    const [showGroupDiscountSection, setShowGroupDiscountSection] = useState(false );
    const [showErrors, updateShowErrors] = useState(false);
    const [currentCard, setCurrentCard] = useState('');
    const [eligibilityInfoChanged, setEligibilityInfoChanged] = useState(false);
    const [paymentInstrumentsForAllPolicies, setPaymentInstrumentsForAllPolicies] = useState([]);
    const [currentUser, setCurrentUser] = useState({});
    const [hasSsn, setHasSsn] = useState(false);
    const [hasDepartmentNumber, setHasDepartmentNumber] = useState(false);
    const [hasEmployeeNumber, setHasEmployeeNumber] = useState(false);
    const [hasMetroBadgeNumber, setHasMetroBadgeNumber] = useState(false);
    const [howPaymentWorks, setHowPaymentWorks] = useState(null);
    const [isVMInitialised, updateIsVMInitialised] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [hidePaymentusIFrame, setHidePaymentusIFrame] = useState(true);
    const [usePaymentusAch, setUsePaymentusAch] = useState(false);
    const [hasAcknowledgedScript, setHasAcknowledgedScript] = useState(false);
    const [isRecurringSameasDownPayment, setIsRecurringSameasDownPayment] = useState(false);
    const [showRecurringPaymentInstrumentError, setShowRecurringPaymentInstrumentError] = useState(false);
    const isModernProduct = _.get(endorsementVM, "isModernProduct_Ext.value", false);
    const [disableNextButton, setDisableNextButton] = useState(false);

    // keep track of child component validation states
    const [childComponentStates] = useState({
        'employersAffiliationsComponent': true,
        'employersAffiliationsEligibilityComponent': true,
        'paymentMethodComponent': true,
        'paymentScheduleComponent': true,
        'recurringPaymentComponent': true,
        'downPaymentComponent': true
    });

    const [paymentInstruments, setPaymentInstruments] = useState([]);
    const [paymentDetailsUrl, setPaymentDetailsUrl] = useState('');

      const {
            ELIG_STATUS
        } = MLGafUtil();

    // constants
    const viewModelService = useContext(ViewModelServiceContext);
    const newBankAccountDetails = useCallback(() => {
        return viewModelService.create({ accountHolder: { value: {} } }, 'pc', 'metlife.edge.capabilities.policyjob.binding.dto.BankAccountDetailsDTOML');
    }, [viewModelService]);
    const paymentDetails = endorsementVM.paymentDetails_ML;
    const gafInfo = endorsementVM.baseData.gafInfo_ML
    const onValidChildComponent = useCallback((isChildComponentValid, id) => {
        childComponentStates[id] = isChildComponentValid;
    }, [childComponentStates]);
    const isChildComponentValid = useCallback((id) => {
        return childComponentStates[id] === true;
    }, [childComponentStates]);
    const paymentMethodCode = useCallback(() => {
        return paymentDetails.ratingPaymentMethod_ML.value ? paymentDetails.ratingPaymentMethod_ML.value.code : '';
    }, [paymentDetails.ratingPaymentMethod_ML.value]);
    const isPayrollDeductionPaymentMethodSelected = useCallback(() => {
        return paymentMethodCode() === MLRatingPaymentMethods.PAYROLL_DEDUCT;
    }, [paymentMethodCode]);
    const lobHO = endorsementVM.lobData.homeowners.value;
    const lobHOAdditionalInterests = endorsementVM.lobData.homeowners.coverables?.additionalInterests?.value

    const isAgent = appConfig.portalCode === 'GPA';
    const isOOSConflict = _.get(endorsementVM, 'isOutOfSequenceConflict_ML.value');
    const productCode = _.get(endorsementVM, 'baseData.productCode.value', '');
    const accountNumber = endorsementVM.baseData.accountNumber.value;
    const termType = _.get(endorsementVM, 'baseData.termType_ML.value.code', '');
    const isBasedOnGPCAvailable = endorsementVM?.value?.baseData?.isBasedOnGPCAvailable;
    const isBasedOnPayroll = _.get(endorsementVM, 'baseData.isBasedOnPayroll.value' , false);
    const [organization, setOrganization] = useState(undefined)

    const _getPaymentusAchFlag = () => {
        return MLPaymentService.usePaymentusACH(gpaMode, authHeader).then((useAch) => {
            setUsePaymentusAch(useAch);
        });
    };

    const refreshPaymentInstruments = useCallback(() => {
        let promiseForJpmcPayInsts
        if (gpaMode) {
            promiseForJpmcPayInsts = MLPaymentService.getPaymentInstruments(
                endorsementVM.sessionUUID.value,
                endorsementVM.jobID.value,
                accountNumber,
                gpaMode,
                authHeader
            );
        } else {
            promiseForJpmcPayInsts = MLPaymentService.getPaymentInstrumentsByPolicyNumber(endorsementVM.policyNumber.value, authHeader);
        }

        showProgressDialog(platformMessages.loading, promiseForJpmcPayInsts);
        return promiseForJpmcPayInsts;
    }, [endorsementVM.sessionUUID.value, endorsementVM.policyNumber.value, endorsementVM.jobID.value, accountNumber, authHeader, showProgressDialog]);

    const _getPaymentInstrumentsForAllPolicies = useCallback(() => {
        const instrumentsPromise = MLPaymentService.getPolicyPaymentInstrumentsForAccount(accountNumber, gpaMode, authHeader);
        instrumentsPromise.then((instruments) => {
            setPaymentInstrumentsForAllPolicies(instruments);
        });
    }, [accountNumber, authHeader]);

    useEffect(() => {
        const updateIsRecurringScript = async () => {
            try {
                const result = await PolicyService.getPolicy(endorsementVM.policyNumber.value, authHeader);
                setIsRecurringSameasDownPayment(result?.billingDetails_ML?.paymentusIframeRecurringSameAsDownPayment_Ext ?? false)
            } catch(error){
                console.log(error);
            }
        };

        updateIsRecurringScript();

        return () => {
            updateIsRecurringScript()
        }
    }, [endorsementVM, PolicyService])

    useEffect(() => {
        if (isAgent) {
            PolChangeTrackEvent('Endorsement Step Reached', false, endorsementVM, authHeader, { step: 'PolChange Billing Details Screen' });
        }

        if(currentStep.path === '/transfer-to-payroll') {
            _.set(endorsementVM, 'payrollDeductionChg_Ext', "transfer_to_payroll")
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const refreshAccountList = useCallback(() => {
        const refreshPromise = refreshPaymentInstruments();
        refreshPromise.then((pms) => {
            setPaymentInstruments(pms);
            _getPaymentInstrumentsForAllPolicies(accountNumber);
        });
        return refreshPromise;
    }, [_getPaymentInstrumentsForAllPolicies, accountNumber, paymentInstruments, refreshPaymentInstruments]);

    const updateExistingCreditCard = useCallback((token, pms) => {
        const pi = pms.find((instrument) => instrument.token === token);
        if (pi && pi.paymentMethod === MLRatingPaymentMethods.CREDIT_CARD || pi.paymentMethod === MLAccountPaymentMethods.CREDIT_CARD) {
            MLPaymentService.updateExistingCreditCardDetails(
                accountNumber,
                pi.token,
                pi.creditCardExpDate,
                pi.last4Digits,
                pi.nickname,
                gpaMode,
                authHeader
            );
        }
    }, [accountNumber, gpaMode]);

    const goToContactUs = (error) => {
        const contactUsPath = 'quote-and-buy/contact-us';
        const url = `${window.location.origin}/${contactUsPath}`;
        window.location.href = url;
    };

    const saveBankAccountDetails = (bankAccountDetails) => {
        const promiseForSaveBankAccountDetails = MLPaymentService.updateBankAccountDetails(
            bankAccountDetails.value,
            accountNumber,
            gpaMode,
            authHeader
        );

        showProgressDialog(platformMessages.loading, promiseForSaveBankAccountDetails);

        promiseForSaveBankAccountDetails.then(() => {
            paymentDetails.selectedPaymentInstrument_ML.value = null;
            setTimeout(() => {
                refreshAccountList();
            }, REFRESH_DELAY);
        }).catch((error) => goToContactUs(error, endorsementVM));
    };

    const editPaymentInstrument = (token, paymentMethod) => {
        if (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD || (usePaymentusAch && paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT)) {
            const paymentusPaymentMethod = paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT ? 'DD' : 'CC';
            const promiseForIFrameUrl = MLGatewayAccountBillingDetailsService.editPaymentInstrument(
                accountNumber,
                token,
                `${window.location.protocol}//${window.location.host}${MLJpmcResponsePath}`,
                paymentusPaymentMethod,
                authHeader
            );
            showProgressDialog(platformMessages.loading, promiseForIFrameUrl, true, 0);
            promiseForIFrameUrl.then((iframeUrl) => {
                const iframeHeight = '600px';
                const iframeWidth = '375px';

                const componentProps = {
                    title: translator(messages.EditAccount),
                    CustomComponent: MLCreditCardDetailsComponent,
                    overrideProps: {
                        jpmcURL: iframeUrl,
                        refreshAccountList: refreshAccountList,
                        iframeHeight,
                        iframeWidth,
                        refreshData,
                        instrumentType: RECURRING_INSTRUMENT_TYPE,
                        updateExistingCreditCard
                    }
                };

                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                );
            }).catch((error) => goToContactUs(error, endorsementVM));
        } else if (!usePaymentusAch && paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT) {
            let promiseForGetBankAccountDetails = null;

            promiseForGetBankAccountDetails = MLPaymentService.getBankAccountDetails(
                token,
                accountNumber,
                gpaMode,
                authHeader);

            showProgressDialog(platformMessages.loading, promiseForGetBankAccountDetails);

            promiseForGetBankAccountDetails.then((details) => {
                const bankAccountDetails = newBankAccountDetails();
                Object.keys(details).forEach((key) => {
                    if (Object.prototype.hasOwnProperty.call(details, key)) {
                        bankAccountDetails[key] = details[key];
                    }
                });

                bankAccountDetails.confirmAccountNumber.value = details.accountNumber;

                const onSaveAction = () => {
                    saveBankAccountDetails(bankAccountDetails);
                    return true;
                };

                const componentProps = {
                    title: translator(messages.EditAccount),
                    CustomComponent: MLBankAccountDetailsComponent,
                    overrideProps: {
                        bankAccountDetails: bankAccountDetails,
                        showCancel: true
                    },
                    onSaveAction
                };

                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                );
            }).catch((error) => goToContactUs(error, endorsementVM));
        }
    };

    const deletePaymentInstrument = async (token, paymentMethod) => {
        let promiseForDeleteCreditCard = null;
        if (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD || paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT) {
            if (ampMode) {
                promiseForDeleteCreditCard = AccountBillingDetailsService.deletePaymentInstrumentByAccount(
                    token,
                    authHeader
                );
            } else {
                promiseForDeleteCreditCard = MLPaymentService.deletePaymentInstrument(
                    endorsementVM.sessionUUID.value,
                    endorsementVM.jobID.value,
                    token,
                    accountNumber,
                    gpaMode,
                    authHeader
                );
            }
            showProgressDialog(platformMessages.loading, promiseForDeleteCreditCard);

            await promiseForDeleteCreditCard.then(() => {
                setTimeout(() => {
                    refreshPaymentInstruments().then((pms) => {
                        if (!pms.some((instrument) => instrument.token === paymentDetails.selectedPaymentInstrument_ML.value)) {
                            paymentDetails.selectedPaymentInstrument_ML.value = null;
                        }
                        setPaymentInstruments(pms);
                    });
                }, REFRESH_DELAY);
            }).catch((error) => goToContactUs(error, endorsementVM));
        }
    };

    const hasPaymentInstrumentsForMethod = useCallback((method) => {
        let hasPaymentInstruments = false;

        paymentInstruments.forEach((paymentInstrument) => {
            if (paymentInstrument.paymentMethod === method && (paymentInstrument.portalAvailable !== false || paymentInstrument.paymentMethod === MLAccountPaymentMethods.CREDIT_CARD)) {
                hasPaymentInstruments = true;
            }
        });

        return hasPaymentInstruments;
    }, [paymentInstruments]);

    const goToSelectedAccordion = (card) => {
        setCurrentCard(card);
        // Before selecting payment plan, user needs to update the quote with eligibility information
        if (card === ACCORDION_CARDS.GROUP_DISCOUNT) {
            paymentDetails.isInPaymentDetailsPage_ML = false;
        }
    };

    const _getUrlQueryParams = (url) => {
        const splitRst = url.split('?');
        const params = {};

        if (splitRst[1]) {
            let query = splitRst[1];
            query = query.split('+').join(' ');

            const re = /[?&]?([^=]+)=([^&]*)/g;
            let tokens = [];

            tokens = re.exec(query);
            while (tokens !== null && tokens.length > 2) {
                const key = decodeURIComponent(tokens[1]);
                const value = decodeURIComponent(tokens[2]);
                params[key] = value;
                tokens = re.exec(query);
            }
        }

        return params;
    };

    const setHttpResponse = () => {
        let token = '';
        let url = '';
        try {
            url = document.getElementById('PaymentDetailsFrame').contentWindow.location.href;
        } catch (error) {
            // do nothing
        }

        const params = _getUrlQueryParams(url);
        token = params.token;

        if (params.DLAction === DL_ACTIONS.ADD_ACOUNT || params.DLAction === DL_ACTIONS.CANCEL || params.DLAction === DL_ACTIONS.EDIT_ACCOUNT) {
            setTimeout(() => {
                refreshPaymentInstruments().then((pmis) => {
                    setPaymentInstruments(pmis);
                    setRecurringPaymentInstrumentById(pmis, token);
                    setHidePaymentusIFrame(true);
                    setPaymentDetailsUrl('');
                    refreshData();
                });
            }, REFRESH_DELAY);
        }
    };

    const setRatingPaymentMethod = useCallback((aRatingPaymentMethod) => {
        
        if (aRatingPaymentMethod !== MLRatingPaymentMethods.MORTGAGEE) {
            paymentDetails.selectedPaymentPlan_ML.value = null;
        } else {
            paymentDetails.ratingPaymentMethod_ML.value = aRatingPaymentMethod;
        }
    }, [paymentDetails.ratingPaymentMethod_ML, paymentDetails.selectedPaymentPlan_ML]);

    const _setMortgageePayFields = useCallback(() => {
        paymentDetails.isPayThroughMortgage_ML.value = true;
        paymentDetails.firstYear_ML.value = true;
        paymentDetails.selectedPaymentPlan_ML.value = MLMortgageePayPlanPublicId;
    }, [paymentDetails.firstYear_ML, paymentDetails.isPayThroughMortgage_ML, paymentDetails.selectedPaymentPlan_ML]);

    const _clearMortgageePayFields = useCallback(() => {
        paymentDetails.isPayThroughMortgage_ML.value = false;
        paymentDetails.firstYear_ML.value = false;
    }, [paymentDetails.firstYear_ML, paymentDetails.isPayThroughMortgage_ML]);

    const setPaymentMethod = useCallback((aRatingPaymentMethod) => {
        let aPaymentMethod = null;

        switch (aRatingPaymentMethod) {
            case MLRatingPaymentMethods.CREDIT_CARD:
                aPaymentMethod = MLAccountPaymentMethods.CREDIT_CARD;
                break;
            case MLRatingPaymentMethods.BANK_ACCOUNT:
                aPaymentMethod = MLAccountPaymentMethods.BANK_ACCOUNT;
                break;
            case MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL:
            case MLRatingPaymentMethods.MORTGAGEE:
                aPaymentMethod = MLAccountPaymentMethods.RESPONSIVE;
                break;
            case MLRatingPaymentMethods.PAYROLL_DEDUCT:
                aPaymentMethod = MLAccountPaymentMethods.PAYROLL_DEDUCT;
                break;
            default:
                break;
        }
        if (paymentDetails.paymentMethod.value !== aPaymentMethod) {
            paymentDetails.selectedPaymentInstrument_ML.value = null;
            paymentDetails.paymentMethod.value = aPaymentMethod;

            if (aRatingPaymentMethod === MLRatingPaymentMethods.MORTGAGEE) {
                _setMortgageePayFields();
            } else if (aRatingPaymentMethod === MLRatingPaymentMethods.PAYROLL_DEDUCT) {
                paymentDetails.selectedPaymentPlan_ML.value = MLPayrollDeductPlanPublicId;
                _clearMortgageePayFields();
            } else {
                paymentDetails.selectedPaymentPlan_ML.value = undefined;
                paymentDetails.bankAccountDetails_ML.value = undefined;
                _clearMortgageePayFields();
            }
        }
    }, [_clearMortgageePayFields, _setMortgageePayFields, paymentDetails]);

    const updateWizardSubmissionData = useCallback((vm) => {
        updateWizardData(_.set(wizardData, 'submissionVM', vm));
    }, [updateWizardData, wizardData]);

    // eslint-disable-next-line consistent-return
    const onNext = () => {
        clearErrorAlerts('transferToPayrollMessage');

        if((currentCard === 'paymentMethodCard') && (!isPayrollDeductionPaymentMethodSelected()) && (currentStep.path === '/transfer-to-payroll')) {

            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            addErrorAlert(translator(messages.transferToPayrollMessage), 'transferToPayrollMessage');

            return false;
        }

        clearErrorAlerts('billingDetailsMessage');

        if((currentCard === 'paymentMethodCard') && (!isBasedOnPayroll) && (isPayrollDeductionPaymentMethodSelected()) && (currentStep.path === '/billing-details')) {

            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            addErrorAlert(translator(messages.billingDetailsMessage), 'billingDetailsMessage');

            return false;
        }

        const ratingPaymentMethodCode = paymentDetails.ratingPaymentMethod_ML.value ? paymentDetails.ratingPaymentMethod_ML.value.code : '';
        if (ratingPaymentMethodCode === MLRatingPaymentMethods.PAYROLL_DEDUCT) {
            const isCardComponentValid = isChildComponentValid('paymentMethodComponent');
            if (isCardComponentValid === false) {
                updateShowErrors(isCardComponentValid === false);
                setErrorTimestamp(errorTimestamp+1);
                return false;
            }
        }
        _.set(endorsementVM, 'shouldRefreshBillingDetails_Ext', true);
        const promise = EndorsementService.saveEndorsement([endorsementVM.value], authHeader);
        showProgressDialog(platformMessages.saving, promise);
        promise.then((policyChangeDTO) => {
            const policyChange = new PolicyChange(policyChangeDTO);
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
            updateWizardSubmissionData(updatedEndorsementVM);

            const lbl = MLEndorsementUtil.stepLabel(currentStep);
            MLEndorsementUtil.setEndorsementDescription(lbl, updatedEndorsementVM, translator);
            MLNavigationStepsTrackingService.completeCurrentStep(null, authHeader);

            if(additionalPolicyChangeProps.isPolicyChangeAndTrasferToPayrollFlow === true) {
                MLEndorsementFlowUtil.addAndNavigateToSelectedStep('PolicyChangeSummaryPage', steps, currentStepIndex, changeNextSteps, goNext, productCode);
            }
            else {
                MLEndorsementFlowUtil.addAndNavigateToSelectedStep('endorsementAdditionalChanges', steps, currentStepIndex, changeNextSteps, goNext, productCode);
             }

            if (isAgent) {
                PolChangeTrackEvent('Endorsement Step Submitted', false, endorsementVM, authHeader, {
                    step: 'PolChange Billing Details Screen',
                    action: 'Billing Details Submitted'
                });
            }

        }).catch(() => {
            // $scope.error = e.baseError.data.error.message;
        });
    };

    const onPayThroughMortgageChange = useCallback((value) => {
        paymentDetails.isPayThroughMortgage_ML.value = value;
        if (value === false) {
            paymentDetails.firstYear_ML.value = null;
        }
    }, [paymentDetails.firstYear_ML, paymentDetails.isPayThroughMortgage_ML]);

    const _setDefaultPaymentMethod = (isMortgagePlanSelected = false, paymentMethodValue = undefined) => {
        // PaymentMethod should have a value which is selected by a customer.
        // On the other than, RatingPaymentMethod may be back to default (Credit Card),
        // That's why we need to check the PaymentMethod value and re-assign.
        if (paymentMethodValue === MLAccountPaymentMethods.BANK_ACCOUNT || paymentMethodValue === MLRatingPaymentMethods.BANK_ACCOUNT) {
            setRatingPaymentMethod(MLRatingPaymentMethods.BANK_ACCOUNT);
        } else if (paymentMethodValue === MLAccountPaymentMethods.CREDIT_CARD || paymentMethodValue === MLRatingPaymentMethods.CREDIT_CARD) {
            setRatingPaymentMethod(MLRatingPaymentMethods.CREDIT_CARD);
        } else if (paymentMethodValue === MLAccountPaymentMethods.PAYROLL_DEDUCT || paymentMethodValue === MLRatingPaymentMethods.PAYROLL_DEDUCT) {
            setRatingPaymentMethod(MLRatingPaymentMethods.PAYROLL_DEDUCT);
        } else if (isMortgagePlanSelected === true) {
            onPayThroughMortgageChange(true);
            setRatingPaymentMethod(MLRatingPaymentMethods.MORTGAGEE);
        } else {
            onPayThroughMortgageChange(false);
            setRatingPaymentMethod(MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL);
        }

        setPaymentMethod(paymentMethodValue);
    };

    const setPaymentInstrument = useCallback((instrument) => {
        if (instrument) {
            paymentDetails.nickname_ML.value = instrument.nickname;
            paymentDetails.last4Digits_ML.value = instrument.last4Digits;
            paymentDetails.creditCardExpDate_ML.value = instrument.creditCardExpDate;
        }
    }, [paymentDetails.creditCardExpDate_ML, paymentDetails.last4Digits_ML, paymentDetails.nickname_ML]);

    const setRecurringPaymentInstrumentById = useCallback((instruments, instrumentId) => {
        const paymentInstrument = instruments.find((instrument) => instrument.token === instrumentId);
        if (!_.isUndefined(paymentInstrument)) {
            paymentDetails.selectedPaymentInstrument_ML.value = instrumentId;
            setPaymentInstrument(paymentInstrument);
        } else {
            paymentDetails.selectedPaymentInstrument_ML.value = null;
        }
    }, [paymentDetails.selectedPaymentInstrument_ML, setPaymentInstrument]);

    // ==================== Users (START) ==================== //
    const isPCSAgent = useCallback(() => {
        return gpaMode && currentUser && currentUser.userType === MLUserTypes.PCS;
    }, [currentUser]);

    const isGcsSalesAgent = useCallback(() => {
        return gpaMode && currentUser && currentUser.userType === MLUserTypes.GCS_SALES;
    }, [currentUser]);

    const isMetGaUser = useCallback(() => {
        return gpaMode && currentUser && ((currentUser.userType === MLUserTypes.PCS && currentUser.primaryProducerCode_ML.producerType_ML === MLProducerTypes.IA)
            || currentUser.userType === MLUserTypes.MET_GA);
    }, [currentUser]);

    const isGcsUser = useCallback(() => {
        return gpaMode && authUserData && (authUserData.userType === MLUserTypes.GCS_SALES || authUserData.userType === MLUserTypes.GCS_SERVICING);
    }, [authUserData]);

    const isMercerUser = useCallback(() => {
        return gpaMode && authUserData?.primaryProducerCode_ML?.organization_ML.name?.toLowerCase()?.includes(mercerOrganization);
    },[authUserData]);

    const isSplUser = useCallback(() => {
        return !isMercerUser() && (isGcsUser() || isMetGaUser());
    }, [isGcsUser, isMetGaUser]);

    const isAgentScripts = useCallback(() => {
        return gpaMode && authUserData && (authUserData.userType === MLUserTypes.GCS_SALES || authUserData.userType === MLUserTypes.GCS_SERVICING || authUserData.userType === MLUserTypes.MET_GA);
    }, [authUserData]);

    const getRatingPaymentMethodCode = useCallback(() => {
        return paymentDetails.ratingPaymentMethod_ML.value ? paymentDetails.ratingPaymentMethod_ML.value.code : '';
    }, [paymentDetails.ratingPaymentMethod_ML.value]);

    const isNotPayOnlineOrByMail = () => {
        return paymentDetails.paymentMethod.value !== MLAccountPaymentMethods.RESPONSIVE;
    };

    const isNotPayrollDeduct = () => {
        return getRatingPaymentMethodCode() !== MLRatingPaymentMethods.PAYROLL_DEDUCT;
    };

    const disableScheduleNext = () => {
        return endorsementVM.isOutOfSequenceConflict_ML.value || _.isUndefined(paymentDetails.selectedPaymentPlan_ML.value);
    };

    const _addPaymentusPaymentInstrument = useCallback((paymentMethodType) => {
        if (paymentMethodType === MLAccountPaymentMethods.CREDIT_CARD) {
            paymentDetails.bankName_ML = JPMC_BANK_NAME;
        } else {
            paymentDetails.bankName_ML = BOA_BANK_NAME;
        }
        const promiseForIframeUrl = MLGatewayAccountBillingDetailsService.getNewPaymentInstrumentUrl(
            accountNumber,
            paymentMethodType,
            `${window.location.protocol}//${window.location.host}${MLJpmcResponsePath}`,
            paymentDetails.preferredPaymentMethodInd_Ext.value,
            isSplUser(),
            authHeader
        );

        showProgressDialog(platformMessages.loading, promiseForIframeUrl, true, 0);

        promiseForIframeUrl.then((iframeUrl) => {
            const switchCondBasedOnScriptParameter = isRecurringSameasDownPayment ? false : (paymentMethodType === MLAccountPaymentMethods.CREDIT_CARD && !hasPaymentInstrumentsForMethod(MLAccountPaymentMethods.CREDIT_CARD))

            if (!isSplUser() && (switchCondBasedOnScriptParameter || (paymentMethodType === MLAccountPaymentMethods.BANK_ACCOUNT && !hasPaymentInstrumentsForMethod(MLAccountPaymentMethods.BANK_ACCOUNT)))) {
                setHidePaymentusIFrame(false);
                setPaymentDetailsUrl(iframeUrl);
            } else {
                const iframeHeight = '650px';
                let iframeWidth = '375px';
                if (isSplUser()) {
                    iframeWidth = '775px';
                }
                const onSaveAction = (instrument) => {
                    // saveNewBankAccountPaymentInstrument(bankAccountDetails);
                    return true;
                };
                const existingPaymentInstruments = paymentInstruments.filter((instrument) => instrument.paymentMethod === paymentMethodType).map((cc) => cc.token);
                const componentProps = {
                    title: translator(messages.AddAccount),
                    CustomComponent: MLCreditCardDetailsComponent,
                    overrideProps: {
                        jpmcURL: iframeUrl,
                        gpaMode: gpaMode,
                        iframeHeight: iframeHeight,
                        iframeWidth: iframeWidth,
                        isDownPaymentInstrument: false,
                        refreshAccountList,
                        setRecurringPaymentInstrumentById,
                        refreshData,
                        instrumentType: RECURRING_INSTRUMENT_TYPE,
                        isSplUser
                    }
                };

                modalApi.showModal(
                    <FormModalPopover {...componentProps} />
                ).catch(() => {
                    refreshAccountList().then((instruments) => {
                        if (isSplUser() || gpaMode) {
                            const newPaymentInstruments = instruments.filter((instr) => instr.paymentMethod === MLAccountPaymentMethods.CREDIT_CARD
                                || (usePaymentusAch && instr.paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT));
                            if (newPaymentInstruments.length > existingPaymentInstruments.length) {
                                const newCard = instruments.find((instrument) => instrument.paymentMethod === paymentMethodType && !existingPaymentInstruments.includes(instrument.token));
                                if (newCard) {
                                    setRecurringPaymentInstrumentById(instruments, newCard.token);
                                }
                            }
                        }
                        refreshData();
                    });
                });
            }
        }).catch((error) => goToContactUs(error, endorsementVM));
    }, [accountNumber, authHeader, endorsementVM, hasPaymentInstrumentsForMethod, isSplUser, paymentDetails, paymentInstruments, refreshAccountList, refreshData, setRecurringPaymentInstrumentById, showProgressDialog, translator, usePaymentusAch]);

    const saveNewBankAccountPaymentInstrument = useCallback((bankAccountDetails) => {
        paymentDetails.bankAccountDetails_ML.value = bankAccountDetails.value;
        paymentDetails.last4Digits_ML.value = bankAccountDetails.accountNumber.value.length > 3 ? bankAccountDetails.accountNumber.value.slice(-4) : bankAccountDetails.accountNumber.value;
        paymentDetails.isAddBankAccount_ML = true;
        paymentDetails.policyNumber_ML.value = endorsementVM.policyNumber.value;

        let promiseForBankAccount = null;

        if (gpaMode) {
            promiseForBankAccount = MLGatewayAccountBillingDetailsService.addBankAccountPaymentInstrument(paymentDetails.value, authHeader);
        } else {
            promiseForBankAccount = AccountBillingDetailsService.addBankAccountPaymentInstrument(paymentDetails.value, authHeader);
        }

        showProgressDialog(platformMessages.loading, promiseForBankAccount);

        promiseForBankAccount.then((newInstrumentId) => {
            paymentDetails.selectedPaymentInstrument_ML.value = newInstrumentId;
            setTimeout(() => {
                refreshAccountList();
            }, REFRESH_DELAY);
        }).catch((error) => goToContactUs(error, endorsementVM))
            .finally(() => {
                paymentDetails.isAddBankAccount_ML = false;
            });
    }, [authHeader, endorsementVM, paymentDetails, refreshAccountList, showProgressDialog]);

    const _addBankAccountPaymentInstrument = useCallback(() => {
        paymentDetails.bankName_ML = BOA_BANK_NAME;
        if (hasPaymentInstrumentsForMethod(MLAccountPaymentMethods.BANK_ACCOUNT)) {
            const onSaveAction = (bankAccountDetails) => {
                saveNewBankAccountPaymentInstrument(bankAccountDetails);
                return true;
            };
            const componentProps = {
                title: translator(messages.AddAccount),
                CustomComponent: MLBankAccountDetailsComponent,
                overrideProps: {
                    bankAccountDetails: newBankAccountDetails(),
                    showCancel: true
                },
                onSaveAction
            }
            modalApi.showModal(
                <FormModalPopover {...componentProps} />
            );
        }
    }, [hasPaymentInstrumentsForMethod, newBankAccountDetails, paymentDetails, saveNewBankAccountPaymentInstrument, translator]);

    const isCreditDebitSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.CREDIT_CARD;
    }, [getRatingPaymentMethodCode]);

    const _defaultPaymentInstrument = useCallback((paymentMethod) => {
        const getFirstPaymentInstrument = (type) => {
            const _paymentInstruments = paymentInstruments
                .filter((instrument) => instrument.paymentMethod === type)
                .sort((a, b) => a.last4Digits - b.last4Digits);

            if (_paymentInstruments.length > 0) {
                return _paymentInstruments[0].token;
            }
            return null;
        };

        const getFirstPreferredPaymentInstrument = (type) => {
            const _paymentInstruments = paymentInstruments
                .filter((instrument) => instrument.paymentMethod === type)
                .sort((a, b) => a.last4Digits - b.last4Digits);

            let instrumentToken = null;
            _paymentInstruments.forEach((instrument) => {
                if (instrumentToken === null && !NON_PREFERRED_PAYMENT_METHODS.includes(instrument.accountType_ML)) {
                    instrumentToken = instrument.token;
                }
            })
            return instrumentToken;
        };

        if (isModernProduct && isCreditDebitSelected() && paymentDetails.preferredPaymentMethodInd_Ext.value === true) {
            paymentDetails.selectedPaymentInstrument_ML.value = getFirstPreferredPaymentInstrument(paymentMethod);
        } else {
            const token = getFirstPaymentInstrument(paymentMethod);
            if (token) {
                setRecurringPaymentInstrumentById(paymentInstruments, token);
                refreshData();
            }
        }
    }, [isCreditDebitSelected, isModernProduct, paymentDetails.preferredPaymentMethodInd_Ext.value, paymentDetails.selectedPaymentInstrument_ML, paymentInstruments, refreshData, setRecurringPaymentInstrumentById]);

    const goToNextAccordion = useCallback(async (nextCard) => {
        if (nextCard === ACCORDION_CARDS.PAYMENT_METHOD) {
            paymentDetails.isInPaymentDetailsPage_ML = true;
        }
        if (nextCard === ACCORDION_CARDS.RECURRING_PAYMENT) {
            setShowRecurringPaymentInstrumentError(false);
            const pms = await refreshPaymentInstruments();
            setPaymentInstruments(pms);

            const paymentMethod = paymentDetails.paymentMethod.value;
            if (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD || paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT) {
                if (paymentDetails.selectedPaymentInstrument_ML.value) {
                    const paymentInstrument = pms.find((instrument) => instrument.token === paymentDetails.selectedPaymentInstrument_ML.value);
                    if (!paymentInstrument) {
                        paymentDetails.selectedPaymentInstrument_ML.value = null;
                    } else {
                        if (isModernProduct && paymentDetails.preferredPaymentMethodInd_Ext.value === true && NON_PREFERRED_PAYMENT_METHODS.includes(paymentInstrument.accountType_ML)) {
                            setShowRecurringPaymentInstrumentError(true);
                        }
                    }
                } else {
                    if (hasPaymentInstrumentsForMethod(paymentMethod) === true) {
                        _defaultPaymentInstrument(paymentMethod);
                    }
                }
            }

            if (!isSplUser() && hasPaymentInstrumentsForMethod(paymentMethod) === false && (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD
                || paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT)) {
                _addPaymentusPaymentInstrument(paymentMethod);
            }
        }

        setCurrentCard(nextCard);
    }, [_addPaymentusPaymentInstrument, _defaultPaymentInstrument, hasPaymentInstrumentsForMethod, isModernProduct, isSplUser, paymentDetails, refreshPaymentInstruments]);

    const updateQuoteDataAndGoToNextAccordion = useCallback((nextCard) => {
        const paymentMethod = paymentDetails.ratingPaymentMethod_ML.value.code;
        const mortgageePay = paymentDetails.isPayThroughMortgage_ML.value;
        const mortgageeFirstYear = paymentDetails.firstYear_ML.value;

        const paymentPlanPromise = EndorsementService.getAvailablePaymentPlans(endorsementVM.jobID.value, paymentMethod, mortgageePay, mortgageeFirstYear, authHeader);
        showProgressDialog(platformMessages.loading, paymentPlanPromise);
        paymentPlanPromise.then((paymentPlans) => {
            paymentDetails.paymentPlans_ML.value = paymentPlans;
            goToNextAccordion(nextCard);
        },
        (error) => {
            console.error(error);
        });
    }, [EndorsementService, authHeader, endorsementVM.jobID.value, goToNextAccordion, paymentDetails.firstYear_ML.value, paymentDetails.isPayThroughMortgage_ML.value, paymentDetails.paymentPlans_ML, paymentDetails.ratingPaymentMethod_ML.value.code, showProgressDialog]);

    // ==================== Helper (START) ==================== //
    const allowAlternatePayor = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.CREDIT_CARD || getRatingPaymentMethodCode() === MLRatingPaymentMethods.BANK_ACCOUNT;
    }, [getRatingPaymentMethodCode]);

    const numberOfPaymentInstrumentsForMethod = (method) => {
        let numPaymentInstruments = 0;

        paymentInstruments.forEach((paymentInstrument) => {
            if (paymentInstrument.paymentMethod === method && (paymentInstrument.portalAvailable !== false || paymentInstrument.paymentMethod === MLRatingPaymentMethods.CREDIT_CARD
                || paymentInstrument.paymentMethod === MLAccountPaymentMethods.CREDIT_CARD)) {
                numPaymentInstruments++;
            }
        });

        return numPaymentInstruments;
    };

    const canRemovePaymentInstrument = (token) => {
        return numberOfPaymentInstrumentsForMethod(paymentDetails.paymentMethod.value) > 1 &&
            paymentInstrumentsForAllPolicies.findIndex((instrumentToken) => instrumentToken === token) === -1;
    };

    // ==================== Flags (START) ==================== //
    const isMortgageeSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.MORTGAGEE;
    }, [getRatingPaymentMethodCode]);

    const hasMortgageesOnEndorsement = useCallback(() => {
        if (!_.isUndefined(lobHO)) {
            return !!lobHOAdditionalInterests.find((interest) => {
                return interest.type === 'FIRSTMORTGAGEE';
            });
        }
        return false;
    }, [lobHOAdditionalInterests, lobHO]);

    const isMortgageePartyMissing = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.MORTGAGEE && !hasMortgageesOnEndorsement();
    }, [getRatingPaymentMethodCode, hasMortgageesOnEndorsement]);

    const isPayOnlineOrMailSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL;
    }, [getRatingPaymentMethodCode]);

    const isPayrollDeductionSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.PAYROLL_DEDUCT;
    }, [getRatingPaymentMethodCode]);

    const isBankAccountSelected = useCallback(() => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.BANK_ACCOUNT;
    }, [getRatingPaymentMethodCode]);

    const isNotValidSelectedPaymentInstrument = useCallback(() => {
        return paymentDetails.selectedPaymentInstrument_ML.value
            && (isCreditDebitSelected() || isBankAccountSelected())
            && paymentInstruments.findIndex((instrument) => {
                return instrument.token === paymentDetails.selectedPaymentInstrument_ML.value
                    && ((instrument.paymentMethod === 'ach' && (usePaymentusAch || (!usePaymentusAch && instrument.portalAvailable === true))) || instrument.paymentMethod === 'creditcard');
            }) === -1;
    }, [isBankAccountSelected, isCreditDebitSelected, paymentDetails.selectedPaymentInstrument_ML.value, paymentInstruments, usePaymentusAch]);

    const isContinueButtonDisabled = () => {
        return endorsementVM.isOutOfSequenceConflict_ML.value
            || (!paymentDetails.selectedPaymentInstrument_ML.value && isNotPayOnlineOrByMail() && isNotPayrollDeduct())
            || (!isNotPayOnlineOrByMail() && disableScheduleNext())
            || isMortgageePartyMissing()
            || currentCard === ACCORDION_CARDS.GROUP_DISCOUNT
            || isNotValidSelectedPaymentInstrument()
            || ((isCreditDebitSelected() || isBankAccountSelected()) && currentCard !== ACCORDION_CARDS.RECURRING_PAYMENT)
            || showRecurringPaymentInstrumentError;
    };

    const isPayByMortgagee = () => {
        return getRatingPaymentMethodCode() === MLRatingPaymentMethods.MORTGAGEE;
    };

    const hidePaymentScheduleSection = useCallback(() => {
        return isMortgageeSelected() || isPayrollDeductionSelected();
    }, [isMortgageeSelected, isPayrollDeductionSelected]);

    const hidePaymentDetailsSection = useCallback(() => {
        return isPayOnlineOrMailSelected() || isPayrollDeductionSelected() || isMortgageeSelected();
    }, [isMortgageeSelected, isPayOnlineOrMailSelected, isPayrollDeductionSelected]);

    const canShowCreditCard = () => {
        return true;
    };

    const _setPayrollDeductFieldsAvailability = useCallback(() => {
        if (gafInfo) {
            setHasSsn(!!gafInfo.ssn.value);
            setHasDepartmentNumber(!!gafInfo.departmentNumber.value);
            setHasEmployeeNumber(!!gafInfo.employeeNumber.value);
            setHasMetroBadgeNumber(!!gafInfo.metroBadgeNumber.value);
        } else {
            setHasSsn(false);
            setHasDepartmentNumber(false);
            setHasEmployeeNumber(false);
            setHasMetroBadgeNumber(false);
        }
    }, [gafInfo]);

    const updateGAFAndGoToNextAccordion = useCallback((nextCard) => {
        gafInfo.isEditMode.value = expandGroupDiscountSection;
        gafInfo.isEditPayrollDeduct.value = false;

        if (!expandGroupDiscountSection) {
            gafInfo.gpcCode.value = null;
            gafInfo.payrollDeductAvailable.value = false;
            gafInfo.eligibilityVerified.value = undefined;
            setExpandGroupDiscountSection(false);
        }

        _setPayrollDeductFieldsAvailability();
        goToNextAccordion(nextCard);
    }, [_setPayrollDeductFieldsAvailability, gafInfo.eligibilityVerified, gafInfo.gpcCode, gafInfo.isEditMode, gafInfo.isEditPayrollDeduct, gafInfo.payrollDeductAvailable, goToNextAccordion, expandGroupDiscountSection]);

    // eslint-disable-next-line consistent-return
    const onNextCard = useCallback(({ card, nextCard }) => {
        clearErrorAlerts('transferToPayrollMessage');

        if((currentCard === 'paymentMethodCard') && (!isPayrollDeductionPaymentMethodSelected()) && (currentStep.path === '/transfer-to-payroll')) {

            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            addErrorAlert(translator(messages.transferToPayrollMessage), 'transferToPayrollMessage');

            return false;
        }

        clearErrorAlerts('billingDetailsMessage');

        if((currentCard === 'paymentMethodCard') && (!isBasedOnPayroll) && (isPayrollDeductionPaymentMethodSelected()) && (currentStep.path === '/billing-details')) {

            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            addErrorAlert(translator(messages.billingDetailsMessage), 'billingDetailsMessage');

            return false;
        }

        const getChildComponent = () => {
            switch (card) {
                case ACCORDION_CARDS.GROUP_DISCOUNT:
                    return 'employersAffiliationsEligibilityComponent';
                case ACCORDION_CARDS.PAYMENT_METHOD:
                    return 'paymentMethodComponent';
                case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                    return 'paymentScheduleComponent';
                case ACCORDION_CARDS.RECURRING_PAYMENT:
                    return 'recurringPaymentComponent';
                default:
                    return '';
            }
        };

        const isValidOtherPayment = () => {
            const isOtherPayorSelected_ML = _.get(endorsementVM, 'value.paymentDetails_ML.isOtherPayorSelected_ML', false);
            
            if (isOtherPayorSelected_ML) {
                const isOtherUpdated = _.get(endorsementVM, 'value.paymentDetails_ML.otherPayor_ML.updated', false);
                
                return isOtherUpdated
            }
            
            return true
        }

        const isCardComponentValid = isChildComponentValid(getChildComponent()) && isValidOtherPayment();
        updateShowErrors(isCardComponentValid === false);
        if (isCardComponentValid === false) {
            setErrorTimestamp(errorTimestamp+1);
        }

        if (isCardComponentValid) {

            if (card === ACCORDION_CARDS.GROUP_DISCOUNT) {

                clearBlockAlerts("gpcRemovedInNonPayroll");
                clearBlockAlerts('redoEligibility');
                clearBlockAlerts('paypointChanged');
                clearBlockAlerts('eligiblityRequired');


                const isEFileVerificationNeededForPD = gafInfo?.eligibleForPayrollDeduct.value === ELIG_STATUS.ELIGIBLE_EFILE_VER_REQUIRED;
                const isEFileVerificationNeededForDB = gafInfo?.eligibleForDirectBill.value === ELIG_STATUS.ELIGIBLE_EFILE_VER_REQUIRED;
                const customerEligibilityFileInd  = gafInfo?.customerEligibilityFileIndicator?.value;
                const isGafInfoChanged = _.get(gafInfo, 'isGpcOrPaypointChanged.value', false)

                
                if(((isPayrollDeductionSelected() && isEFileVerificationNeededForPD) || 
                    (!isPayrollDeductionSelected() && isEFileVerificationNeededForDB))
                     && customerEligibilityFileInd 
                    && gafInfo.eligibilityVerified.value 
                    && (_.isEmpty(_.get(endorsementVM, 'baseData.employeeInfo_ML.value.name')) 
                    || _.isEmpty(_.get(endorsementVM, 'baseData.employeeInfo_ML.value.address')))
                ){
                    addErrorAlert(translator(messages.eligibilityVerificationIncomplete), 'redoEligibility');
                    updateShowErrors(true);
                    setErrorTimestamp(errorTimestamp + 1);
                    
                    return;
                } else if(isBasedOnPayroll && isGafInfoChanged) {

                    addErrorAlert(messages.paypointChangedMsg, "paypointChanged");
                    updateShowErrors(true);
                    setErrorTimestamp(errorTimestamp + 1);

                  return;
                }
                else if(isPayrollDeductionSelected() && isEFileVerificationNeededForPD && customerEligibilityFileInd && _.isEmpty(_.get(endorsementVM, 'baseData.employeeInfo_ML.value.name'))) {
                    addErrorAlert(messages.eligRequiredMsg, 'eligiblityRequired');
                    updateShowErrors(true);
                    setErrorTimestamp(errorTimestamp + 1);

                    return;
                } else if(isEFileVerificationNeededForDB && customerEligibilityFileInd && _.isEmpty(_.get(endorsementVM, 'baseData.employeeInfo_ML.value.name'))) {
                    addErrorAlert(messages.eligRequiredMsg, 'eligiblityRequired');
                    updateShowErrors(true);
                    setErrorTimestamp(errorTimestamp + 1);

                    return;
                }

            if(((!isBasedOnPayroll && isBasedOnGPCAvailable) || expandGroupDiscountSection ) 
                && !gafInfo?.gpcCode?.value) {

                  addErrorAlert(messages.gpcRemovedInNonPayroll, "gpcRemovedInNonPayroll");
                  updateShowErrors(true);
                  setErrorTimestamp(errorTimestamp + 1);

                  return;
            }

                updateGAFAndGoToNextAccordion(nextCard);
            } else if (card === ACCORDION_CARDS.PAYMENT_METHOD) {
                    if(gafInfo?.gpcCode) {
                        clearBlockAlerts('eligiblityRequired');

                const isEFileVerificationNeededForDB = gafInfo?.eligibleForDirectBill?.value === ELIG_STATUS.ELIGIBLE_EFILE_VER_REQUIRED;
                const customerEligibilityFileInd  = gafInfo?.customerEligibilityFileIndicator?.value;
                const eligRequiredMsg = "Please go to group affiliation/discount and complete the eligibility verification to continue!";

                    if(!isPayrollDeductionSelected() && isEFileVerificationNeededForDB && customerEligibilityFileInd && _.isEmpty(_.get(endorsementVM, 'baseData.employeeInfo_ML.value.name'))) {
                        addErrorAlert(eligRequiredMsg, 'eligiblityRequired');
                        updateShowErrors(true);
                        setErrorTimestamp(errorTimestamp + 1);

                        return;
                    }
                }
                updateQuoteDataAndGoToNextAccordion(ACCORDION_CARDS.PAYMENT_SCHEDULE);
            } else if (card === ACCORDION_CARDS.PAYMENT_SCHEDULE) {
                if (!hidePaymentDetailsSection()) {
                    goToNextAccordion(ACCORDION_CARDS.RECURRING_PAYMENT);
                }
            } else {
                setCurrentCard(nextCard);
            }
        }
    }, [errorTimestamp, goToNextAccordion, hidePaymentDetailsSection, isChildComponentValid, updateGAFAndGoToNextAccordion, updateQuoteDataAndGoToNextAccordion]);

    const onPaymentMethodChangedAlert = (newValue) => {
        clearBlockAlerts('changingPaymentMethod');
        if (newValue && !eligibilityInfoChanged) {
            addWarningAlert(messages.changingPaymentMethodAffectPremium, 'changingPaymentMethod');
        }
    };

    const onPaymentInstrumentChange = (paymentInstrumentToken) => {
        if (!_.isUndefined(paymentInstrumentToken)) {
            setShowRecurringPaymentInstrumentError(false);

            const paymentInstrument = paymentInstruments.find((instrument) => instrument.token === paymentInstrumentToken);
            if (!_.isUndefined(paymentInstrument)) {
                setRecurringPaymentInstrumentById(paymentInstruments, paymentInstrumentToken);

                if (isModernProduct && paymentDetails.preferredPaymentMethodInd_Ext.value === true) {
                    if (NON_PREFERRED_PAYMENT_METHODS.includes(paymentInstrument.accountType_ML)) {
                        setShowRecurringPaymentInstrumentError(true);
                    }
                }
            } else {
                view.paymentDetails.selectedPaymentInstrument_ML.value = null;
            }
            refreshData();
        }
    };

    const showEditAction = useCallback((card) => {
        switch (card) {
            case ACCORDION_CARDS.GROUP_DISCOUNT:
                return currentCard === ACCORDION_CARDS.PAYMENT_METHOD || currentCard === ACCORDION_CARDS.PAYMENT_SCHEDULE || currentCard === ACCORDION_CARDS.RECURRING_PAYMENT;
            case ACCORDION_CARDS.PAYMENT_METHOD:
                return currentCard === ACCORDION_CARDS.PAYMENT_SCHEDULE || currentCard === ACCORDION_CARDS.RECURRING_PAYMENT;
            case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                return currentCard === ACCORDION_CARDS.RECURRING_PAYMENT;
            default:
                return false;
        }
    }, [currentCard]);

    const _getSelectedPaymentPlanName = useCallback((planValue) => {
        switch (planValue) {
            case MLMortgageePayPlanPublicId:
                return translator(messages.Mortgage);
            case MLAnnuallyPayPlanPublicId:
                return translator(messages.AnnualPayment);
            case MLMonthlyPayPlanPublicId:
            case MLMonthlyAnnualResponsivePlanPublicId:
            case MLMonthlySemiAnnualResponsivePlanPublicId:
                return translator(messages.MonthlyPayment);
            case MLTwicePerMonthPayPlanPublicId:
                return translator(messages.TwicePerMonth);
            case MLTwoPayAnnualPlanPublicId:
            case MLTwoPaySemiAnnualPlanPublicId:
                return translator(messages.TwoPay);
            case MLFourPayAnnualPlanPublicId:
                return translator(messages.FourPay);
            case MLPayrollDeductPlanPublicId:
                return translator(messages.PayrollDeduct);
            default:
                return '';
        }
    }, [translator]);

    const _getDayWithOrdinalIndicator = (dayOfMonth = 0) => {
        if (dayOfMonth > 3 && dayOfMonth < 21) {
            return `${dayOfMonth}th`;
        }

        switch (dayOfMonth % 10) {
            case 1:
                return `${dayOfMonth}st`;
            case 2:
                return `${dayOfMonth}nd`;
            case 3:
                return `${dayOfMonth}rd`;
            default:
                return `${dayOfMonth}th`;
        }
    };

    const _secondPaymentDayOfMonth = (firstPaymentDayOfMonth) => {
        if (firstPaymentDayOfMonth >= 1 && firstPaymentDayOfMonth <= 15) {
            return firstPaymentDayOfMonth + 15;
        }

        return firstPaymentDayOfMonth - 15;
    };

    const showPaymentScheduleInfo = useCallback((selectedPaymentPlanML, paymentDayOfMonthML) => {
        let paymentDayOfMonthMLInt = paymentDayOfMonthML;
        if(!_.isNaN(parseInt(paymentDayOfMonthMLInt))) { 
            paymentDayOfMonthMLInt = parseInt(paymentDayOfMonthML);
        };  
        if (MLTwicePerMonthPayPlanPublicId === selectedPaymentPlanML) {
            return `${_getDayWithOrdinalIndicator(paymentDayOfMonthMLInt)} &
            ${_getDayWithOrdinalIndicator(_secondPaymentDayOfMonth(paymentDayOfMonthMLInt))}`;
        }

        return _getDayWithOrdinalIndicator(paymentDayOfMonthMLInt);
    }, []);

    const getSubHeaderDescription = useCallback((card) => {
        switch (card) {
            case ACCORDION_CARDS.PAYMENT_METHOD:
                return getPaymentMethodName(paymentDetails.ratingPaymentMethod_ML.value.code);
            case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                return translator(messages.PaymentScheduleSubHeader, {
                    paymentPlan: _getSelectedPaymentPlanName(paymentDetails.selectedPaymentPlan_ML.value),
                    paymentSchedule: showPaymentScheduleInfo(paymentDetails.selectedPaymentPlan_ML.value, paymentDetails.paymentDayOfMonth_ML?.value)
                });
            case ACCORDION_CARDS.RECURRING_PAYMENT:
                return translator(messages.PaymentDetailsSubHeader, {
                    nickname: paymentDetails.nickname_ML.value,
                    last4Digits: paymentDetails.last4Digits_ML.value
                });
            default:
                return '';
        }
    }, [_getSelectedPaymentPlanName, getPaymentMethodName, paymentDetails.last4Digits_ML.value, paymentDetails.nickname_ML.value, paymentDetails.ratingPaymentMethod_ML.value.code, paymentDetails.selectedPaymentPlan_ML.value, showPaymentScheduleInfo, translator, paymentDetails.paymentDayOfMonth_ML?.value]);

    const editCard = useCallback((card) => {
        if (isComponentValid === false) {
            updateShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
        }
        if (!_.isUndefined(card)) setCurrentCard(card);
    }, [errorTimestamp, isComponentValid]);

    const onHeaderClicked = useCallback((card) => {
        editCard(card.name);
    }, [editCard]);

    const getAccordionCardTitle = useCallback((card) => {
        switch (card) {
            case ACCORDION_CARDS.GROUP_DISCOUNT:
                return translator(messages.groupProgramEligibilityTitle);
            case ACCORDION_CARDS.PAYMENT_METHOD:
                return translator(messages.paymentMethodTitle);
            case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                return translator(messages.paymentFrequencyTitle);
            case ACCORDION_CARDS.RECURRING_PAYMENT:
                return translator(messages.paymentDetailsTitle);
            default:
                return '';
        }
    }, [translator]);

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.nextBaseDescription}
                values={{
                    bold: (
                        <strong>{translator(messages.nextDescriptionBold)}</strong>
                    )
                }}
            />
        );
    };

    const getAccordionNumber = (card) => {
        let number = 0;
        switch (card) {
            case ACCORDION_CARDS.PAYMENT_METHOD:
                number += 1;
                break;
            case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                number += 2;
                break;
            case ACCORDION_CARDS.RECURRING_PAYMENT:
                number += 3;
                break;
            default:
                break;
        }
        if (!showGroupDiscountSection) {
            return number;
        }
        return number + 1;
    };

    const renderHeader = useCallback((active, card) => {
        const index = getAccordionNumber(card);

        return (
            <div className="ml-payment-header">
                <div className={classNames("ml-payment-header__main-content", { active: active })}>
                    <span className='ml-count-icon ml-panel-set__item-indicator large static'>
                        {index}
                    </span>

                    <div className="ml-panel-set__item-title">
                        {getAccordionCardTitle(card)}
                    </div>

                    {showEditAction(card) && (
                        <span className="edit-link">
                            <Link id={`edit${index}`}>{translator(messages.Edit)}</Link>
                        </span>
                    )}
                </div>
                <div className="ml-payment-header__secondary-content">
                    {showEditAction(card) && (
                        <span className="ml-payment-header__secondary-content__sub-heading">
                            {getSubHeaderDescription(card)}
                        </span>
                    )}
                </div>
            </div>
        );
    }, [getAccordionCardTitle, getSubHeaderDescription, showEditAction, translator]);

    const addRecurringPaymentInstrument = () => {
        const paymentMethod = paymentDetails.paymentMethod.value;
        if (paymentMethod === MLAccountPaymentMethods.CREDIT_CARD || (usePaymentusAch && paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT)) {
            _addPaymentusPaymentInstrument(paymentMethod);
        } else if (!usePaymentusAch && paymentMethod === MLAccountPaymentMethods.BANK_ACCOUNT) {
            _addBankAccountPaymentInstrument();
        }
    };

    const setFaqSection = useCallback((faqId) => {
        setHowPaymentWorks(translator(messages.PaymentPlanFaqSection, faqId));
    }, [translator]);

    const selectPaymentPlan = (selectedPlanName) => {
        switch (selectedPlanName) {
            case MLMortgageePayPlanPublicId:
                paymentDetails.selectedPaymentPlan_ML.value = MLMortgageePayPlanPublicId;
                paymentDetails.ratingPaymentSchedule_ML.value = 'full_pay';
                break;
            case MLAnnuallyPayPlanPublicId:
                paymentDetails.selectedPaymentPlan_ML.value = MLAnnuallyPayPlanPublicId;
                paymentDetails.ratingPaymentSchedule_ML.value = 'full_pay';
                // annualPaymentButton = selectedText;
                // monthlyPaymentButton = biWeeklyButton = twoPaymentButton = selectText;
                break;
            case MLMonthlyPayPlanPublicId:
                paymentDetails.selectedPaymentPlan_ML.value = MLMonthlyPayPlanPublicId;
                paymentDetails.ratingPaymentSchedule_ML.value = 'installments';
                // monthlyPaymentButton = selectedText;
                // annualPaymentButton = biWeeklyButton = twoPaymentButton = selectText;
                setFaqSection('how-does-monthly-pay-option-work');
                break;
            case MLBiWeeklyPayPlanPublicId:
                paymentDetails.selectedPaymentPlan_ML.value = MLBiWeeklyPayPlanPublicId;
                paymentDetails.ratingPaymentSchedule_ML.value = 'installments';
                // biWeeklyButton = selectedText;
                // annualPaymentButton = monthlyPaymentButton = twoPaymentButton = selectText;
                setFaqSection('how-does-twice-per-month-payment-work');
                break;
            case MLTwoPayPlanPublicId:
                paymentDetails.selectedPaymentPlan_ML.value = MLTwoPayPlanPublicId;
                paymentDetails.ratingPaymentSchedule_ML.value = 'installments';
                // twoPaymentButton = selectedText;
                // annualPaymentButton = monthlyPaymentButton = biWeeklyButton = selectText;
                break;
            default:
                paymentDetails.selectedPaymentPlan_ML.value = selectedPlanName;
                break;
        }
        refreshData();
    };

    const isPaymentScriptChecked = (value) => {
        setHasAcknowledgedScript(value);
        refreshData();
    }
    const isPaymentScheduleNextDisabled = () => {
        if (isAgentScripts() && (paymentDetails.paymentMethod.value === MLAccountPaymentMethods.CREDIT_CARD ||
            paymentDetails.paymentMethod.value === MLAccountPaymentMethods.BANK_ACCOUNT)) {
            return !(paymentDetails.selectedPaymentPlan_ML.value && hasAcknowledgedScript)
        }
        return !paymentDetails.selectedPaymentPlan_ML.value;
    }
    const setPaymentInstrumentById = (instrumentId) => {
        const paymentInstrument = paymentInstruments.find((instrument) => instrument.token === instrumentId);
        if (!_.isUndefined(paymentInstrument)) {
            paymentDetails.selectedPaymentInstrument_ML.value = instrumentId;
            setPaymentInstrument(paymentInstrument);
        } else {
            paymentDetails.selectedPaymentInstrument_ML.value = null;
        }
    };

    const _getGroupAccessPermission = (endorsement) => {
        MLStateRolloutService.checkIsGroupEnabled(endorsement.baseData?.policyAddress.state, authHeader).then((isGroupEligible) => {
            isGroupEligible = endorsement?.baseData?.producerCodeOfService_ML?.producerType_ML === "ia" ? false : isGroupEligible            
            setShowGroupDiscountSection(isGroupEligible);

            if (isGroupEligible) {
                goToSelectedAccordion(ACCORDION_CARDS.GROUP_DISCOUNT);
            } else {
                goToSelectedAccordion(ACCORDION_CARDS.PAYMENT_METHOD);
            }
        });
    };

    const _initCurrentUser = useCallback(() => {
        if (gpaMode) {
            UserService.getCurrentUser(authHeader).then((user) => {
                setCurrentUser(user);
                if (user?.primaryProducerCode_ML?.organization_ML) {
                        setOrganization(user.primaryProducerCode_ML.organization_ML)
                }
            });
        }
    }, [authHeader]);

    const selectPreferredPaymentMethodInd = useCallback((value) => {
        paymentDetails.preferredPaymentMethodInd_Ext.value = value;
        updateWizardSubmissionData(endorsementVM);
    }, [paymentDetails.preferredPaymentMethodInd_Ext, updateWizardSubmissionData, endorsementVM]);

    useEffect(() => {
        Identify('Endorsement Step Reached', {step: 'Billing Details Screen'}, endorsementVM, authHeader)
    }, [])

    useEffect(() => {
        async function getPaymentusFlag() {
            await _getPaymentusAchFlag();
        }

        async function getGroupAccessPermission(endorsement) {
            await _getGroupAccessPermission(endorsement);
        }

        MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.updatedBillingDetails), false, currentStep.mlStepName, authHeader);
        getPaymentusFlag().then(() => {
            refreshAccountList();
            if (paymentDetails.ratingPaymentMethod_ML.value) {
                setPaymentMethod(paymentDetails.ratingPaymentMethod_ML.value.code);
            }
        });
        getGroupAccessPermission(endorsementVM.value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isVMInitialised) {
            _initCurrentUser();
            _setPayrollDeductFieldsAvailability();
            updateIsVMInitialised(true);
        }
    }, [_initCurrentUser, _setPayrollDeductFieldsAvailability, accountNumber, isVMInitialised]);

    // ==================== JPMC Integration (START) ==================== //

    const resolvers = {
        resolveComponentMap: {
            mloutofsequenceconflictcomponent: MLOutOfSequenceConflictComponent,
            mlemployersaffiliationscomponent: MLEmployersAffiliationsComponent,
            mlpaymentmethodcomponent: MLPaymentMethodComponent,
            mlpaymentschedulecomponent: MLPaymentScheduleComponent,
            mlrecurringpaymentcomponent: MLRecurringPaymentComponent,
            mlwizardpageactions: MLWizardPageActions
        },
        resolveCallbackMap: {
            onValidate,
            onNextCard,
            onNext,
            renderHeader,
            onHeaderClicked,
            onVerifyEligibility: () => {}
        },
        resolveClassNameMap: styles
    };

    const getIsCollapsible = (card) => {
        switch (card) {
            case ACCORDION_CARDS.GROUP_DISCOUNT:
                return currentCard !== ACCORDION_CARDS.GROUP_DISCOUNT;
            case ACCORDION_CARDS.PAYMENT_METHOD:
                return currentCard === ACCORDION_CARDS.PAYMENT_SCHEDULE || currentCard === ACCORDION_CARDS.RECURRING_PAYMENT;
            case ACCORDION_CARDS.PAYMENT_SCHEDULE:
                return currentCard === ACCORDION_CARDS.RECURRING_PAYMENT;
            case ACCORDION_CARDS.RECURRING_PAYMENT:
                return false;
            default:
                return true;
        }
    };

    const overrides = {
        oosComponent: {
            isOOSConflict,
            isAgent
        },
        mlBillingChangeDetailsContainer: {
            className: isAgent ? 'page-content-gpa' : ''
        },
        nextDescription: {
            content: getNextStepText()
        },
        accordionContainer: {
            accordionStates: [currentCard],
        },
        groupDiscountCard: {
            isCollapsible: getIsCollapsible(ACCORDION_CARDS.GROUP_DISCOUNT),
            visible: showGroupDiscountSection
        },
        groupDiscountOptions: {
            value: expandGroupDiscountSection,
            onValueChange: (value) => {
                if (value !== expandGroupDiscountSection) {
                    setExpandGroupDiscountSection(value);
                    if (getRatingPaymentMethodCode() === MLRatingPaymentMethods.PAYROLL_DEDUCT) {
                        _setDefaultPaymentMethod(false, false);
                    }
                }
            },
            visible: !isBasedOnGPCAvailable,
        },
        employersAffiliationsComponent: {
            onValidate: onValidChildComponent,
            visible: expandGroupDiscountSection,
            model: endorsementVM,
            updateWizardData: updateWizardSubmissionData,
            isPaymentScreen: true,
            isEndorsement: true,
            showErrors,
            setDisableNextButton: setDisableNextButton,
            isCurrentPayPlanPayroll: isPayrollDeductionSelected,
            isBasedOnPayroll,
            organization
        },
        paymentMethodCard: {
            isCollapsible: getIsCollapsible(ACCORDION_CARDS.PAYMENT_METHOD)
        },
        paymentMethodComponent: {
            submissionVM: endorsementVM,
            updateShowErrors,
            onValidate: onValidChildComponent,
            showValidationErrors: showErrors,
            paymentDetails,
            paymentInstruments,
            gafInfoObject: {
                gafInfo,
                choseEligibility: expandGroupDiscountSection
            },
            hasDepartmentNumber,
            hasEmployeeNumber,
            hasMetroBadgeNumber,
            gpaMode,
            qnbMode,
            hasSsn,
            periodStartDate: endorsementVM.baseData.periodStartDate.value,
            productCode: endorsementVM.baseData.productCode,
            coveragePartType: _.get(endorsementVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', ''),
            premium: endorsementVM.totalCost.value,
            hasMortgagees: hasMortgageesOnEndorsement(),
            isEndorsement: true,
            currentUser,
            isBasedOnPayroll,
            updateWizardData: updateWizardSubmissionData,
            onRatingPaymentMethodChange: (value) => {
                onPaymentMethodChangedAlert(true);
                setPaymentMethod(value.code);
                // _initPaymentPlan(value.code);
                // disregardFieldValidation('paymentMethodComponent');
                // updateWizardData(endorsementVM);
                refreshData();
            },
            selectPaymentPlan,
            refreshPaymentPage: refreshData,
            steps,
            jumpTo,
            addAndJumpToInterestedPartiesStep: () => MLEndorsementFlowUtil.addAndNavigateToSelectedStep('endorsementInterestedParties', steps, currentStepIndex, changeNextSteps, goNext, productCode),
            visible: currentCard === ACCORDION_CARDS.PAYMENT_METHOD
        },
        paymentMethodActionRow: {
            visible: !(isPayrollDeductionSelected() || isPayByMortgagee())
        },
        paymentMethodNextCardButton: {
            disabled: isMortgageeSelected() && !hasMortgageesOnEndorsement()
        },
        paymentScheduleActionRow: {
            visible: isNotPayOnlineOrByMail()
        },
        paymentScheduleCard: {
            visible: !hidePaymentScheduleSection(),
            isCollapsible: getIsCollapsible(ACCORDION_CARDS.PAYMENT_SCHEDULE)
        },
        recurringPaymentCard: {
            visible: !hidePaymentDetailsSection(),
            isCollapsible: getIsCollapsible(ACCORDION_CARDS.RECURRING_PAYMENT)
        },
        paymentScheduleComponent: {
            onValidate: onValidChildComponent,
            showValidationErrors: showErrors,
            paymentDetails: paymentDetails,
            isEndorsement: true,
            offeredQuotes: [],
            chosenQuote: {},
            termType,
            gpaMode,
            selectPaymentPlan,
            isPaymentScriptChecked,
            visible: currentCard === ACCORDION_CARDS.PAYMENT_SCHEDULE,
            selectPreferredPaymentMethodInd,
            isModernProduct,
            submissionVM: endorsementVM
        },
        paymentScheduleNextCardButton: {
            disabled: isPaymentScheduleNextDisabled()
        },
        recurringPaymentComponent: {
            onValidate: onValidChildComponent,
            showValidationErrors: showErrors,
            paymentDetails,
            paymentInstruments,
            onPaymentInstrumentChange,
            addRecurringPaymentInstrument,
            canShowCreditCard,
            isCreditDebitSelected,
            isBankAccountSelected,
            hasPaymentInstrumentsForMethod,
            saveNewBankAccountPaymentInstrument,
            setHttpResponse,
            paymentDetailsUrl,
            canRemovePaymentInstrument,
            editPaymentInstrument,
            deletePaymentInstrument,
            allowAlternatePayor,
            setErrorTimestamp,
            errorTimestamp,
            visible: currentCard === ACCORDION_CARDS.RECURRING_PAYMENT,
            isCreditCardOveridden: hidePaymentusIFrame,
            isGcsSalesAgent,
            isSplUser,
            isPolicyChange: true,
            usePaymentusAch,
            showRecurringPaymentInstrumentError
        },
        nextButton: {
            disabled: isContinueButtonDisabled()
        },
        billingHeader: {
            visible: !ampMode
        },
        groupDiscountButton: {
            disabled: disableNextButton,
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={isAgent ? messages.makeChanges : messages.billingDetail}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={endorsementVM}
                onModelChange={updateWizardSubmissionData}
                onValidationChange={onValidate}
                showErrors={showErrors}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
};

BillingDetailsPagePolChange.propTypes = wizardProps;
export default BillingDetailsPagePolChange;
